/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  GetApiSentEmailList200,
  GetApiSentEmailList400,
  GetApiSentEmailListParams,
  GetApiSentSmsList200,
  GetApiSentSmsList400,
  GetApiSentSmsListParams,
  NotFoundErrorResponse,
  SentEmailDetailApiResource,
  SentSmsApiResource,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiSentEmailGetResponse200 = {
  data: SentEmailDetailApiResource
  status: 200
}

export type getApiSentEmailGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiSentEmailGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiSentEmailGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiSentEmailGetResponseSuccess = (getApiSentEmailGetResponse200) & {
  headers: Headers;
};
export type getApiSentEmailGetResponseError = (getApiSentEmailGetResponse401 | getApiSentEmailGetResponse403 | getApiSentEmailGetResponse404) & {
  headers: Headers;
};

export type getApiSentEmailGetResponse = (getApiSentEmailGetResponseSuccess | getApiSentEmailGetResponseError)

export const getGetApiSentEmailGetUrl = (id: number,) => {


  

  return `/api/sent-emails/${id}`
}

export const getApiSentEmailGet = async (id: number, options?: RequestInit): Promise<getApiSentEmailGetResponse> => {
  
  return customFetch<getApiSentEmailGetResponse>(getGetApiSentEmailGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiSentSmsGetResponse200 = {
  data: SentSmsApiResource
  status: 200
}

export type getApiSentSmsGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiSentSmsGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiSentSmsGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiSentSmsGetResponseSuccess = (getApiSentSmsGetResponse200) & {
  headers: Headers;
};
export type getApiSentSmsGetResponseError = (getApiSentSmsGetResponse401 | getApiSentSmsGetResponse403 | getApiSentSmsGetResponse404) & {
  headers: Headers;
};

export type getApiSentSmsGetResponse = (getApiSentSmsGetResponseSuccess | getApiSentSmsGetResponseError)

export const getGetApiSentSmsGetUrl = (id: number,) => {


  

  return `/api/sent-sms/${id}`
}

export const getApiSentSmsGet = async (id: number, options?: RequestInit): Promise<getApiSentSmsGetResponse> => {
  
  return customFetch<getApiSentSmsGetResponse>(getGetApiSentSmsGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiSentEmailListResponse200 = {
  data: GetApiSentEmailList200
  status: 200
}

export type getApiSentEmailListResponse400 = {
  data: GetApiSentEmailList400
  status: 400
}

export type getApiSentEmailListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiSentEmailListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiSentEmailListResponseSuccess = (getApiSentEmailListResponse200) & {
  headers: Headers;
};
export type getApiSentEmailListResponseError = (getApiSentEmailListResponse400 | getApiSentEmailListResponse401 | getApiSentEmailListResponse403) & {
  headers: Headers;
};

export type getApiSentEmailListResponse = (getApiSentEmailListResponseSuccess | getApiSentEmailListResponseError)

export const getGetApiSentEmailListUrl = (params?: GetApiSentEmailListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sent-emails?${stringifiedParams}` : `/api/sent-emails`
}

export const getApiSentEmailList = async (params?: GetApiSentEmailListParams, options?: RequestInit): Promise<getApiSentEmailListResponse> => {
  
  return customFetch<getApiSentEmailListResponse>(getGetApiSentEmailListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiSentSmsListResponse200 = {
  data: GetApiSentSmsList200
  status: 200
}

export type getApiSentSmsListResponse400 = {
  data: GetApiSentSmsList400
  status: 400
}

export type getApiSentSmsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiSentSmsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiSentSmsListResponseSuccess = (getApiSentSmsListResponse200) & {
  headers: Headers;
};
export type getApiSentSmsListResponseError = (getApiSentSmsListResponse400 | getApiSentSmsListResponse401 | getApiSentSmsListResponse403) & {
  headers: Headers;
};

export type getApiSentSmsListResponse = (getApiSentSmsListResponseSuccess | getApiSentSmsListResponseError)

export const getGetApiSentSmsListUrl = (params?: GetApiSentSmsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/sent-sms?${stringifiedParams}` : `/api/sent-sms`
}

export const getApiSentSmsList = async (params?: GetApiSentSmsListParams, options?: RequestInit): Promise<getApiSentSmsListResponse> => {
  
  return customFetch<getApiSentSmsListResponse>(getGetApiSentSmsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


